import dog from './dog.png';
import cat from './cat.png';


const animalSelectionAssets = [
  {
    avatar: 'dog',
    imgSrc: dog,
  }, 
  {
    avatar: 'cat',
    imgSrc: cat,
  },
]

export { animalSelectionAssets }

